import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["startDate", "endDate"]

  today(event) {
    event.preventDefault()
    const today = new Date()
    this.setRange(today, today)
  }

  yesterday(event) {
    event.preventDefault()
    const yesterday = new Date()
    yesterday.setDate(yesterday.getDate() - 1)
    this.setRange(yesterday, yesterday)
  }

  thisWeek(event) {
    event.preventDefault()
    const today = new Date()
    const day = today.getDay()
    const offsetToMonday = day === 0 ? -6 : 1 - day
    const start = new Date(today)
    start.setDate(today.getDate() + offsetToMonday)
    const end = new Date(start)
    end.setDate(start.getDate() + 6)
    this.setRange(start, end)
  }

  thisMonth(event) {
    event.preventDefault()
    const today = new Date()
    const start = new Date(today.getFullYear(), today.getMonth(), 1)
    const end = new Date(today.getFullYear(), today.getMonth() + 1, 0)
    this.setRange(start, end)
  }

  setRange(start, end) {
    if (this.hasStartDateTarget) this.startDateTarget.value = this.formatDate(start)
    if (this.hasEndDateTarget) this.endDateTarget.value = this.formatDate(end)
    const form = this.element.closest("form")
    if (form) form.requestSubmit()
  }

  formatDate(date) {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, "0")
    const day = String(date.getDate()).padStart(2, "0")
    return `${year}-${month}-${day}`
  }
}
